import React from 'react';

import { Typography, Grid, Box, Container } from "@mui/material";

import PRINCIPALIMAGE from '../../assets/IFW_SoftwareCHARTS-04.png'


const AccumulationChart = () => {
    const chartTitleStyle = { color: 'grey', fontWeight: 'bold', fontSize: '18px', margin: '0.2em', marginTop: '1em' }

    return (<Grid container>
        <Box xs={10} ml={6}  style={{ display: 'flex', flexDirection: 'row', marginLeft: '10%' }}  >
            <Typography style={chartTitleStyle}> WHEN YOU ARE ACCUMULATING MONEY, </Typography>
            <Typography style={{ ...chartTitleStyle, color: '#157ee8', textDecoration: 'underline', cursor: 'pointer' }} id={"link-button"} > THE SEQUENCE OF RETURNS DOESN’T MATTER </Typography>
        </Box>
        <Grid container  justifyContent={'center'}>
            <Grid item xs={10 } >
            <img src={PRINCIPALIMAGE} style={{ width: '100%', height: '100%', objectFit: 'fill' }} />
            </Grid>
        </Grid>

        <Box xs={10} ml={6} style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em', marginLeft: '10%' }}  >
            <Typography style={{ ...chartTitleStyle, fontSize: '16px' }}> End Result: During Accumulation </Typography>
            <Typography style={{ ...chartTitleStyle, fontSize: '16px', color: '#157ee8', textDecoration: 'underline', cursor: 'pointer' }} id={"link-button"} > The Sequence of Returns Does Not Affect </Typography>
            <Typography style={{ ...chartTitleStyle, fontSize: '16px' }}> Your Final Account Value </Typography>

        </Box>
    </Grid>)
}

export default AccumulationChart;